import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig";
import * as Yup from "yup";
let moduleConfig = {};
moduleConfig = {
  ...moduleDefaultConfig,
};

moduleConfig.hasStatusSearch = false;

moduleConfig.title = "Party Requests";
moduleConfig.singleItemTitle = "Party Request";
moduleConfig.url = "party-requests";

moduleConfig.buttons = {
  create: false,
  view: true,
  update: false,
  delete: true,
};

moduleConfig.bulkActions = [
  {
    displayName: "Delete Selected",
    value: "Delete",
  },
];

moduleConfig.fields = [
  {
    displayName: "ID",
    fieldName: "_id",
    type: "text",
    control: "hidden",
  },
  {
    displayName: "Parent Name",
    fieldName: "parentName",
    type: "text",
    control: "input",
    showOnListing: true,
    sortable: true,
  },
  {
    displayName: "Email",
    fieldName: "email",
    type: "email",
    control: "input",
    showOnListing: true,
    sortable: true,
  },

  {
    displayName: "Mobile",
    fieldName: "mobile",
    type: "number",
    control: "input",
    showOnListing: true,
    sortable: true,
    displayStyle: "phone",
  },
  {
    displayName: "Event Date",
    fieldName: "eventDate",
    type: "dateTime",
    showOnListing: true,
    sortable: true,
    displayStyle: "text",
  },
  {
    displayName: "Event Time",
    fieldName: "eventTime",
    type: "text",
    showOnListing: false,
    sortable: false,
    displayStyle: "text",
  },
  {
    displayName: "Number Of Children",
    fieldName: "numberOfChildren",
    type: "text",
    control: "input",
    showOnListing: true,
    sortable: true,
  },

  {
    displayName: "Address",
    fieldName: "address",
    type: "text",
    showOnListing: false,
    sortable: false,
    displayStyle: "text",
  },
  {
    displayName: "City",
    fieldName: "city",
    type: "text",
    showOnListing: false,
    sortable: false,
    displayStyle: "text",
  },
  {
    displayName: "Occasion",
    fieldName: "occasion",
    type: "text",
    showOnListing: true,
    sortable: false,
    displayStyle: "text",
  },
  {
    displayName: "Message",
    fieldName: "message",
    type: "text",
    showOnListing: false,
    sortable: false,
    displayStyle: "text",
  },

  {
    displayName: "Submission Date & Time",
    fieldName: "createdAt",
    type: "date",
    showOnListing: true,
    sortable: true,
  },
];
moduleConfig.initialValues = {};
moduleConfig.validationSchema = Yup.object({});

export default moduleConfig;
